export function calcStudioSourcePosition(scene, source) {
    return {
        dx: (source.positionX / 100) * scene.width,
        dy: (source.positionY / 100) * scene.height,
        dw: (source.width / 100) * scene.width,
        dh: (source.height / 100) * scene.height,
    };
}
